import FilterOrderByStatus from './FilterOrderByStatus/FilterOrderByStatus'
import FilterOrderInput from './FilterOrderInput/FilterOrderInput'
import OrderMenuActions from './OrderMenuActions/OrderMenuActions'

export const options = {
  FilterOrderInput,
  FilterOrderByStatus,
  OrderMenuActions
}
